import { Helper } from '../Helper';
export class ArrEveryHelper extends Helper {
    constructor(options) {
        super();
        this.map =
            options.map === undefined
                ? () => {
                }
                : options.map;
    }
    emit(sb, node, options) {
        sb.emitSysCall(node, 'Neo.Enumerator.Create');
        sb.emitHelper(node, options, sb.helpers.rawEnumeratorEvery({
            each: this.map,
        }));
    }
}

//# sourceMappingURL=ArrEveryHelper.js.map
